import Workspaces from '@mui/icons-material/Workspaces';
import People from '@mui/icons-material/People';
import DeviceHub from '@mui/icons-material/DeviceHub';
import Event from '@mui/icons-material/Event';
import Password from '@mui/icons-material/Password';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Map from '@mui/icons-material/Map';
import BioMonitorIcon from '@mui/icons-material/Monitor';
import BioCreditIcon from '@mui/icons-material/Nature';
import CarbonCreditIcon from '@mui/icons-material/Cloud';
import Public from '@mui/icons-material/Public';
import { NavConfig, ProfileNavItem } from './nav.types';
import { Assessment, VpnKey } from '@mui/icons-material';

export const navConfig: NavConfig = {
  ADMIN: [
    { text: 'Projects', path: '/admin/projects', icon: Workspaces },
    { text: 'Deployments', path: '/admin/deployments', icon: Event },
    { text: 'Devices', path: '/admin/devices', icon: DeviceHub },
    { text: 'Users', path: '/admin/users', icon: People },
    {
      text: 'API Management',
      path: '/admin/api-management',
      icon: VpnKey,
      children: [
        { text: 'API Keys', path: '/admin/api-management/keys', icon: VpnKey },
        { text: 'API Endpoints', path: '/admin/api-management/endpoints', icon: Assessment },
      ]
    },
  ],
  USER: [
    { text: 'Overview', path: '/project/:id/overview', icon: Public },
    {
      text: 'Carbon', path: '/project/:id/carbon-dashboard', icon: CarbonCreditIcon,
      moduleKey: 'has_carbon_module',
      children: [
        { text: 'Dashboard', path: '/project/:id/carbon-dashboard', icon: Assessment },
        // Hidding credit view until further notice
        // { text: 'Credit', path: '/project/:id/carbon-credit', icon: Redeem },
        // TODO: Enable map view when the feature is ready
        // { text: 'Map View', path: '/project/:id/carbon-interactive-map', icon: Map } 
      ],
    },
    {
      text: 'Biodiversity', path: '/project/:id/bio-diversity-dashboard', icon: BioCreditIcon,
      moduleKey: 'has_biodiversity_module',
      children: [
        { text: 'Dashboard', path: '/project/:id/bio-diversity-dashboard', icon: Assessment },
        // Hidding credit view until further notice
        // { text: 'Credit', path: '/project/:id/bio-diversity-credit', icon: Redeem },
        { text: 'Map View', path: '/project/:id/bio-diversity-interactive-map', icon: Map }
      ],
    },
    {
      text: 'Climate', path: '/project/:id/climate-dashboard', icon: BioMonitorIcon, moduleKey: 'has_environmental_module',
      children: [
        { text: 'Dashboard', path: '/project/:id/climate-dashboard', icon: Assessment },
        // TODO: Enable credit view when the feature is ready
        // { text: 'Map View', path: '/project/:id/climate-interactive-map', icon: Map }
      ]
    },
  ],
  EMPLOYEE: [
    { text: 'Projects', path: '/admin/projects', icon: Workspaces },
    { text: 'Deployments', path: '/admin/deployments', icon: Event },
  ],
};

// Common routes for user profile, can be used in the user dropdown menu
export const profileNavs: ProfileNavItem[] = [
  { text: 'Account', path: '/profile/update-user', icon: AccountCircle },
  { text: 'Change Password', path: '/profile/change-password', icon: Password },
];
